export default "__VITE_ASSET__CahMbpAi__"